import { render } from "./BaseDashboardFilters.vue?vue&type=template&id=2244bf9c"
import script from "./BaseDashboardFilters.vue?vue&type=script&lang=js"
export * from "./BaseDashboardFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseDashboardFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2244bf9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2244bf9c', __exports__)) {
    api.reload('2244bf9c', __exports__)
  }
  
  module.hot.accept("./BaseDashboardFilters.vue?vue&type=template&id=2244bf9c", () => {
    api.rerender('2244bf9c', render)
  })

}


export default __exports__